import React, { useEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import airconunitService from "../services/airconunit.service";
import { Airconunitvalidationschema } from "../components/Validation";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import Loader from "../components/Loader";
import Toastmessage from "../components/Toastmessage";
import { useNavigate, useSearchParams } from "react-router-dom";
import Alertmsg from "../components/Alertmsg";

const Airconunitevent = (props) => {
  let navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();

  const ref = useRef();
  const [isLoaded, setIsLoaded] = useState(false);
  const [eventname, setEventname] = useState("view");

  const [au_id, setAirconunitid] = useState();

  //form initial value
  const formik = useFormik({
    initialValues: {
      au_id: "",
      au_name: "",
      au_status: "",
    },
    validationSchema: Airconunitvalidationschema,
    /*  validateOnChange: false,
         validateOnBlur: false, */
    onSubmit: (values, { resetForm }) => {
      //alert(JSON.stringify(values, null, 1));
      /*  resetForm({ values: '' }) */
    },
  });
  //use effects
  useEffect(() => {
    setAirconunitid(searchParams.get("au_id"));
    if (searchParams.get("au_id")) {
      setEventname("view");
      getAirconunit(searchParams.get("au_id"));
    } else {
      setEventname("create");
    }
  }, []);

  //current event
  const airconunitEvent = (eventname, value) => {
    if (value) {
      getAirconunit(value);
    }
    setEventname(eventname);
  };

  //get airconunit
  const getAirconunit = (value) => {
    setIsLoaded(true);
    airconunitService
      .getAirconunit(value)
      .then((res) => {
        if (res.data.result) {
          setIsLoaded(false);
          let data = res.data.result;
          formik.setValues({
            au_id: data.au_id,
            au_name: data.au_name,
            au_status: data.au_status == null ? "" : data.au_status,
          });
        } else {
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
      });
  };
  //create airconunit
  const createAirconunit = () => {
    airconunitService
      .createAirconunit(formik.values)
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          navigate("/airconunit");
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        ref.current.toastlog(false, err.message);
        setIsLoaded(false);
      });
  };
  //update airconunit
  const updateAirconunit = () => {
    airconunitService
      .updateAirconunit(formik.values)
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          airconunitEvent("view");
          setIsLoaded(false);
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        ref.current.toastlog(false, err.message);
        setIsLoaded(false);
      });
  };
  //delete airconunit
  const deleteAirconunit = (value) => {
    airconunitService
      .deleteAirconunit(String(value))
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          navigate("/airconunit");
          setIsLoaded(false);
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        ref.current.toastlog(false, err.message);
        setIsLoaded(false);
      });
  };
  // Call airconunit clicks to request another page.
  if (isLoaded) {
    <Loader />;
  } else {
    return (
      <div className="container">
        {/*  container */}
        <div className="airconunit-container">
          {/* form container */}
          <div className="card shadow-sm border-0 ">
            <div className="card-body ">
              <div className="d-flex">
                <h5 className="card-title p-0 m-0 me-auto">Airconunit</h5>
                {eventname == "create" ? (
                  <></>
                ) : (
                  <div>
                    <div className="dropdown">
                      <a
                        className="btn  btn-link"
                        href="#"
                        role="button"
                        id="airconuniteventdropdownMenuLink"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                      </a>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="airconuniteventdropdownMenuLink"
                      >
                        <li>
                          <a
                            onClick={() => {
                              airconunitEvent("edit");
                            }}
                            className="dropdown-item"
                          >
                            Edit
                          </a>
                        </li>
                        <li>
                          <a
                            onClick={() => airconunitEvent("delete")}
                            className="dropdown-item"
                          >
                            Delete
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
              <form onSubmit={formik.handleSubmit}>
                <div className="row">
                  {/*  profile section */}
                  <div className="col-md-4">
                    <label htmlFor="au_id" className="form-label">
                      Id
                    </label>
                    <div className="input-group">
                      <input
                        className="form-control"
                        placeholder="Enter Id"
                        id="au_id"
                        type="text"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "edit"
                            ? true
                            : eventname == "delete"
                            ? true
                            : false
                        }
                        {...formik.getFieldProps("au_id")}
                      />
                    </div>
                    <div>
                      {formik.touched.au_id && formik.errors.au_id ? (
                        <div className="error">{formik.errors.au_id}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-5">
                    <label htmlFor="au_name" className="form-label">
                      Airconunitname
                    </label>
                    <div className="input-group col-md-6">
                      <input
                        className="form-control"
                        placeholder="Enter airconunitname"
                        id="au_name"
                        type="text"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "delete"
                            ? true
                            : false
                        }
                        {...formik.getFieldProps("au_name")}
                      />
                    </div>
                    <div>
                      {formik.touched.au_name && formik.errors.au_name ? (
                        <div className="error">{formik.errors.au_name}</div>
                      ) : null}
                    </div>
                  </div>

                  <div className="col-md-3">
                    <label htmlFor="au_status" className="form-label">
                      status
                    </label>
                    <div className="input-group col-md-6">
                      <select
                        id="au_status"
                        {...formik.getFieldProps("au_status")}
                        className="form-select"
                        disabled={
                          eventname == "view"
                            ? true
                            : eventname == "delete"
                            ? true
                            : false
                        }
                        aria-label="au_status"
                      >
                        <option value="" disabled>
                          Select status
                        </option>
                        <option value="pending">Pending</option>
                        <option value="active">Active</option>
                        <option value="inactive">Inactive</option>
                      </select>
                    </div>
                    <div>
                      {formik.touched.au_status &&
                      formik.errors.au_status ? (
                        <div className="error">{formik.errors.au_status}</div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </form>
              <div className="pt-2 pb-2">
                {eventname === "create" ? (
                  <>
                    <button
                      disabled={!formik.isValid}
                      onClick={() => createAirconunit()}
                      className="btn btn-primary me-2"
                    >
                      Create
                    </button>
                    <button
                      onClick={formik.handleReset}
                      className="btn btn-secondary"
                    >
                      Clear
                    </button>
                  </>
                ) : eventname === "edit" ? (
                  <>
                    {" "}
                    <button
                      onClick={() => updateAirconunit()}
                      className="btn btn-primary me-2"
                    >
                      Update
                    </button>
                    <button
                      onClick={() => airconunitEvent("view")}
                      className="btn btn-secondary"
                    >
                      Cancel
                    </button>
                  </>
                ) : eventname === "delete" ? (
                  <>
                    <button
                      onClick={() => deleteAirconunit(formik.values.au_id)}
                      className="btn btn-danger me-2 "
                    >
                      Delete
                    </button>
                    <button
                      onClick={() => airconunitEvent("view")}
                      className="btn btn-secondary"
                    >
                      Cancel
                    </button>
                  </>
                ) : (
                  <>
                    {/* <button onClick={() => navigate('/airconunitloyee')} className='btn btn-primary' >Back</button> */}
                  </>
                )}
              </div>
            </div>
          </div>
          {/*  loader and error handler */}
          {/*  {iserror === false || iserror === true ? <Alertmsg alertmsg={ismessage} type={iserror} /> : <></>} */}
          <Toastmessage ref={ref} />
          {/* <Alertmsg ref={ref}/> */}
        </div>
      </div>
    );
  }
};

export default Airconunitevent;
